import RecapBase from "./RecapBase";

const GameweekRecap = () => (
  <RecapBase type="gameweek" redirectPath="/gameweek-recap" />
);

export default GameweekRecap;
